import { Link, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const dashPath = ["admin", "super_admin"].includes(user?.role) ? "/admin"
    : user?.role === "professional" ? "/pro/dashboard" : "/dashboard";

  return (
    <header className="bg-navy border-b border-white/10 sticky top-0 z-40" data-testid="app-header">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="app-header-logo" className="flex items-center gap-3">
          <span className="w-8 h-8 bg-flame flex items-center justify-center font-heading font-black text-white text-lg">P</span>
          <span className="font-heading font-black text-white tracking-tight">PRIME PRO</span>
        </Link>
        {user && (
          <div className="flex items-center gap-4">
            <button
              data-testid="app-header-dashboard-btn"
              onClick={() => navigate(dashPath)}
              className="flex items-center gap-2 text-white/80 hover:text-flame text-sm transition-colors"
            >
              <LayoutDashboard size={16} /> Dashboard
            </button>
            <span className="text-white/40 text-sm hidden sm:block">{user.name}</span>
            <button
              data-testid="app-header-logout-btn"
              onClick={async () => { await logout(); navigate("/"); }}
              className="flex items-center gap-2 text-white/60 hover:text-flame text-sm transition-colors"
            >
              <LogOut size={16} /> Log out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default AppHeader;
